import { Select } from '@backstage/ui';
import '../../../select-overlay.css';

interface AutocompleteFieldProps {
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}

export const AutocompleteField = ({
  label,
  value,
  options,
  onChange,
  disabled = false,
  required = false,
  placeholder,
}: AutocompleteFieldProps) => {
  return (
    <Select
      label={label}
      name={label}
      size="medium"
      value={value || null}
      onChange={key => {
        const next = String(key ?? '');
        if (next === value) {
          return;
        }
        if (next && !options.includes(next)) {
          return;
        }
        onChange(next);
      }}
      isDisabled={disabled}
      isRequired={required}
      search={{
        placeholder: placeholder ?? 'Digite para filtrar...',
        filter: (item, query) =>
          String(item.label ?? item.id)
            .toLowerCase()
            .includes((query ?? '').trim().toLowerCase()),
      }}
      options={options.map(option => ({ id: option, label: option }))}
    />
  );
};
